import React from 'react';
import PropTypes from 'prop-types';

import './User.scss';

export default class UserRenderer extends React.Component {
	static propTypes = {
		user: PropTypes.object.isRequired,
		withoutPhoto: PropTypes.bool
	};

	render() {
		let {firstname, surname, email, picture} = this.props.user;

		let name = [firstname, surname].filter(item => item || false).join(' ');

		name = name || '-';

		return (
			<div className="UserRenderer">
				{ this.props.withoutPhoto
					? null
					: <img className="profilePicture" src={picture} />
				}
				{name}
				{email ? <span>&nbsp;&lt;{email}&gt;</span> : null}
			</div>
		);
	}
}
